<template>
<div>

  <template v-if="schema.isShowStatis=='tongji' && schema.views>0">
    <div class="text-center" style="padding:10px 0">
      <van-circle
        v-model="currentRate"
        :size="schema.views > 10000 ? 100 : 60"
        :stroke-width="60"
        color="#67C23A"
        :text="schema.views + ''"
      />
      <div class="text-center help">扫码次数</div>
    </div>
  </template>
  

  <template v-if="schema.isShowStatis=='fangwei' && schema.views>0">

    <div class="text-center" style="padding:10px 0" >
      <van-circle
        v-model="currentRate"
        :size="schema.views > 10000 ? 100 : 60"
        :stroke-width="60"
        color="#67C23A"
        :text="schema.views + ''"
      />
      <div class="text-center table-statis-success" v-if="schema.views ==1">恭喜您是第1位扫码用户</div>
      <div class="text-center table-statis-warning" v-else>您不是第1位扫码用户</div>
    </div>

    <div class="fangwei-log" v-if="schema.saoma_log">
      <div v-for="(item, idx) in schema.saoma_log" :key="'log-'+idx">第{{item.views}}次：{{item.time}} {{item.addr}}</div>
    </div>
  </template>

  <div class="help text-center" v-if="schema.fields.length <=0">
    未配置显示字段
  </div>
  <div v-else>
    <div :style="'padding:'+schema.paddingTB+'px '+schema.paddingLR+'px;'">
      <!-- 封面图片先显示 -->
      <div v-for="(item, idx) in schema.fields" :key="idx" style="margin-bottom:10px;">
          <div v-if="item.type=='image' && item.value!='' && item.value!=null" @click="onImagePreview(item.value)">
              <img style="width:100%;display:block;" v-lazy="item.value[0]"/>
          </div>
      </div>

      <template v-if="schema.isShowMode=='accordion'">
        <!-- 手风琴 -->
        <van-collapse v-model="schema.accordionActive" accordion>
          <template  v-for="(item, idx) in schema.fields" >
            <template v-if="item.type !='map' && item.type=='image' && item.type !='pdf' && item.label!=''" >
              <van-collapse-item :title="item.label" :name="idx"  :key="idx">{{item.value}}</van-collapse-item>
            </template>
          </template>
        </van-collapse>
      </template>
      <template v-else>
        <!-- 显示表 -->
        <section class="diy-editor">
            <table class="table" style="font-size: 14px; table-layout: fixed;  width: 100%;">
                <tbody>
                  <template  v-for="(item, idx) in schema.fields" >
                    <tr v-if="item.type !='map' && item.type !='image' && item.type !='pdf' && item.label!=''" :key="idx">
                        <td :style="'width:'+ schema.leftWidth+'%; word-break: break-all;padding: 8px 10px; border: 1px solid '+schema.borderColor+'; color:'+schema.color+';'">
                            {{item.label}}
                        </td>
                        <td :style="'word-break: break-all;padding: 8px 10px; border: 1px solid '+schema.borderColor+'; color:'+schema.color+';'">
                          {{item.value}}
                        </td>
                    </tr>
                  </template>
                  
                </tbody>
            </table>
        </section>
        
      </template>
    </div>
    <!-- pdf -->
    <template v-for="(item, idx) in schema.fields" >
      <van-cell-group v-if="item.type=='pdf' && item.value!='' && item.value!=null"  :key="'pdf-'+idx">
        <div class="block-title">{{item.label}}</div>
        <van-cell 
          v-for="(pdfItem, pdfIdx) in item.value" :key="'pdf-i-'+pdfIdx" 
          :title="pdfItem.name" :value="pdfItem.size_format"  @click="openPDF(pdfItem)" is-link>
          <div slot="icon" class="qr-type-icon">
            <van-icon name="https://v.2weima.com/static/images/icon/pdf.png" :size="23"  />
          </div>
        </van-cell>
      </van-cell-group>
    </template>


    <!-- 地图在后面显示 -->
    <div v-for="(item, idx) in schema.fields" :key="'map-'+idx" >
        <div v-if="item.type=='map' && item.value!='' && item.value!=null"  @click="openMap(item)">
            <img style="width:100%;display:block;" :src="getMapUrl(item.value)"/>
        </div>
    </div>

  

  </div>



  <van-popup v-model="viewMapLocation" @close="viewMapLocation = false" :style="{ height: '100%',width:'100%' }" close-icon="close" class="map-popup" closeable >
    <div style="width:100%;height:100%;" v-if="mapLocation.lat !=''">
    <iframe id="mapPage" style="width:100%;height:100%;" frameborder=0
        :src="'https://apis.map.qq.com/uri/v1/marker?marker=coord:'+ mapLocation.lat +','+mapLocation.lng +';title:'+ encodeURIComponent(mapLocation.title)+';addr:'+ encodeURIComponent(mapLocation.address)+'&referer=2weima.com'">
    </iframe>
    </div>
  </van-popup>

</div>
</template>

<script>
import utils from "../../../utils/utils"
export default {
  name: 'diyTable',
  props: {
    schema: {
      'type':Object,
      default:{},
      required:true
    },
    pluginIndex:{
      type:Number,
      default:0
    }
  },
  data:function(){
    return {
      currentRate:100,
      viewMapLocation:false,
      mapLocation:{
        lat:'',
        lng:'',
        title:'',
        address:''
      }
    }
  },
  methods:{
    onImagePreview(src){
      utils.handelImagePreview(src)
    },
    getMapUrl:function(mapData){
      // console.log(mapData);
      if(JSON.stringify(mapData) =='{}'|| mapData =="" || mapData.poi ==""  ){
        return '/static/images/demo-map.png';
      }
      if(mapData.level<4){
        mapData.level = 4;
      }
      if(mapData.level>18){
        mapData.level = 18;
      }
      return 'https://apis.map.qq.com/ws/staticmap/v2/?center='+mapData.poi+'&zoom='+mapData.level+'&size=400*400&scale=1&maptype=roadmap&markers=size:large|color:red|'+mapData.poi+'&key=BMWBZ-GXD6W-WQYRC-R7ZEC-SONP7-E7FXO';
    },
    openMap:function(fieldData){

      // table组件
      if(!fieldData.value){
        return ;
      }
      var _poi = fieldData.value.poi || ''
      if(_poi==''){
        return ;
      }
      _poi = _poi.split(',')
      this.mapLocation = {
        lat:_poi[0] || '',
        lng:_poi[1] || '',
        title:fieldData.value.name,
        address:fieldData.value.address
      };


      this.viewMapLocation = true;

      // if(JSON.stringify(mapData) =='{}'|| mapData =="" || mapData.poi ==""  ){
      //   return '/static/images/demo-map.png';
      // }
      // if(mapData.level<4){
      //   mapData.level = 4;
      // }
      // if(mapData.level>18){
      //   mapData.level = 18;
      // }
      // var mapSrc = 'https://apis.map.qq.com/uri/v1/marker?marker=coord:'+ mapData.poi +';title:'+ encodeURIComponent(mapData.name)+';addr:'+ encodeURIComponent(mapData.address)+'&referer=2weima.com';
      // location.href = mapSrc;
    },
    openPDF:function(fileData){
      // console.log('fileData',fileData)
      utils.handleLink(fileData.url)
    }
    

  }
}
</script>

<style>

.table{border-collapse:collapse!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}
/* .table-statis{
	color: #666;
} */
.table-statis-success{
	color: #07c160;
}
.table-statis-warning{
	color: #ee0a24;
}
.fangwei-log{
  margin:6px;
  padding:10px; 
  border:1px solid #DDDDDD;
  font-size:14px;
}

.map-popup .van-popup__close-icon{
  color: red !important;
  font-size: 30px !important;
}
</style>